import { isArray, isNil } from "lodash-es";

import { ISelectProps } from "@/eworkitComponents";

export interface IUseSimpleValueParams<T> extends Pick<ISelectProps<T>, "isMulti" | "onChange" | "options" | "value"> {
  simpleValue?: boolean;
  valueKey: string;
}

export function useSimpleValue<T extends { [index: string]: any }>(params: IUseSimpleValueParams<T>) {
  const { isMulti, onChange, options, simpleValue, value, valueKey } = params;

  if (!simpleValue) {
    return { handleChange: onChange, value: value ? value : null };
  }

  const handleChange = (changedValue: T | null) => {
    if (onChange) {
      if (!isNil(changedValue)) {
        const v = changedValue as T;
        const simplifiedValue = isMulti ? v.map((chosenValue: any) => chosenValue[valueKey]) : v[valueKey];
        onChange(simplifiedValue);
      } else {
        onChange(null);
      }
    }
  };

  const parsedValue = () => {
    if (!isNil(value)) {
      if (isArray(options)) {
        if (isMulti) {
          const values = value as any;
          return options.filter(o => {
            return values.find((v: any) => o[valueKey] === v);
          });
        } else {
          return options.find(option => {
            return option[valueKey] === value;
          });
        }
      }

      return value;
    }

    return value;
  };

  return { handleChange, value: parsedValue() };
}
